import { RecurringSchedule } from './survey-create.model';
export interface SurveyList {
  endDate: Date;
  groupNames: string[];
  participantCount: number;
  productName?: string;
  productId: number;
  responseCount: number;
  responseRate?: number;
  startDate: Date;
  surveyId: number;
  surveyName: string;
  isCustomName?: boolean;
  createdBy?: string;
  activatedBy?: string;
  activatedOn?: Date;
  selectable?: boolean;
}
export enum RecurringSurveyStatus {
  'Active' = 'Active',
  'Inactive' = 'Inactive',
  'Completed' = 'Completed'
}
export enum RecurringPauseReason {
  'TrialEnded' = 'TrialEnded',
  'SubscriptionCancelled' = 'SubscriptionCancelled',
  'SubscriptionExpired' = 'SubscriptionExpired'
}
export interface RecurringSurveyList {
  id: number;
  productId: number;
  startDate: Date;
  endDate: Date;
  responseRate?: number;
  expectedCount: number;
  answerCount: number;
  name: string;
  status: RecurringSurveyStatus;
  duration: number;
  reporting: TimeSpan;
  schedule: RecurringSchedule;
  anchorDate: Date;
  lastRunEndDate?: Date;
  nextOccurrence: Date;
  firstOccurrence: Date;
  editLocked: boolean;
  pausedUntil?: Date | null;
  /** Set when the survey was paused because its product access ended. */
  accessPauseReason?: RecurringPauseReason | null;
  groups: {id: number, name: string}[];
}

export interface PinCode {
  groupName: string;
  pinCode: string;
}

export enum SurveyStatus {
  Ongoing = 'Ongoing',
  Upcoming = 'Upcoming',
  Finished = 'Finished'
}

export interface SurveyListModel {
  id: number;
  name: string;
  communicationType: string;
}

export interface TimeSpan {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
